
<template>
	<div class="headder">
		<div class="head-cont clear">
			<div class="logo-lk fl">
				<a :href="baseUrl" class="logo-c">
					<img v-if="logoUrl" :src="BASE_URL + logoUrl" alt="logo">
					<!-- <img v-else src="../../../../public/logo.png" alt="logo"> -->
				</a>
				<a v-if="logoTxt" :href="baseUrl" class="logo-txt">{{logoTxt}}</a>
				<i>·</i>
				<router-link to="/netteach" class="link-home">网络教研</router-link>
			</div>
			<router-link class="newAdd fr" to="/netteach/add">发起评课</router-link>
		</div>
	</div>
</template>

<script>
	
	export default{
		data(){
			return {
            baseUrl: process.env.BASE_URL,
            logoUrl: sessionStorage.getItem('logoUrl'),
            logoTxt: sessionStorage.getItem('logoTxt'),
			}
		},
		created(){

		},
		methods: {
			
		}
	}
</script>

<style lang="scss">
	.headder{
		background: #fff;
		height: 80px;
		box-shadow: 0 2px 4px 0 rgba(195,195,195,0.30);
	}
	.head-cont{
		padding: 15px 25px 0 25px;
	}
	.logo-c{
		display: inline-block;
		vertical-align: top;
		max-width: 180px;
		height: 40px;
		overflow: hidden;
		>img{
			width: 100%;
			// max-height: 40px;
		}
		>span{
			font-size: 22px;
			margin: 0 5px 0 10px;
			font-weight: bold;
		}
	}
	.logo-lk{
		>a{
			line-height: 40px;
		}
		>i{
			margin: 0 5px;
			font-weight: bold;
		}
		.link-home{
			font-size: 16px;
			color: #000000;
			letter-spacing: 2px;

		}
	}

	.train-test{
		button{
			background: #348EFC;
			border-radius: 3px;
			width: 120px;
			height: 36px;
			line-height: 36px;
			text-align: center;
			color: #fff;
			padding: 0;
		}
		>a,>span{
			display: inline-block;
			vertical-align: top;
			line-height: 36px;
			color: #338efc;
			margin-right: 30px;
			cursor: pointer;
		}
	}

	.newAdd{
		background: #338efc;
		border-radius: 3px;
		line-height: 40px;
		height: 40px;
		width: 100px;
		text-align: center;
		font-size: 16px;
		color: #ffffff;
		display: block;
	}
</style>